import React from 'react';
import { Link } from 'react-router-dom';
import type { NavItem } from '../Header.types';

interface NavigationProps {
    items: NavItem[];
}

const Navigation: React.FC<NavigationProps> = ({ items }) => {
    return (
        <ul className="ms-auto pt-[1rem] pb-[1.5rem] bg-primary">
            {items.map((item) => (
                <li key={item.id} className="nav-item  mb-1">
                    <Link
                        to={item.to}
                        className="underline-animate  text-[2rem] text-white"
                        aria-current={item.active ? "page" : undefined}
                    >
                        {item.label}
                    </Link>
                </li>
            ))}
        </ul>
    );
};

export default Navigation;
